import { SettingsViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const mockSettings: SettingsViewModel = {
  draftTTL: 72,
  highPayWarningLimit: 150000,
  monthlyReportingReleaseDate: '2024-01-01',
  payMonthMargin: 12,
  ffSurveyMultiReporter: true,
  ffCompressFileUpload: true,
  ffChangeParameterEndDate: true,
  ffManageEmployeeAndEmployment: true,
  ffFaGroupIdOnEmployment: true,
};
